export default "__VITE_ASSET__yxuQS8eP__"